import { cScrollPercent } from './cScrollPercent';

class Contest {
  constructor() {
    this.isScrollingFlag = false;
    this.scroll100Indicator = 0;
    this.statElementCollector = {};
    this.slidePositionVieved = {};
    this.lastScrollTop = 0;
    this.isScrollingDown = false;
    this.activeSlug = null;
    this.lastReportedSlug = null;
    this.indT = [];
    this._load();
  }

  _load() {
    let idTS;
    window.addEventListener('scroll', () => {
      this.isScrollingController(true);
      if (idTS) {
        clearTimeout(idTS);
      }
      idTS = setTimeout(() => {
        idTS = null;
        this.isScrollingController(false);
      }, 50);
      const st = window.scrollX || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.isScrollingDown = true;
        document.querySelector('.header').classList.add('header--translated');
      } else {
        this.isScrollingDown = false;
        document.querySelector('.header').classList.remove('header--translated');
      }
      this.lastScrollTop = st <= 0 ? 0 : st;
    });
  }

  getScrollingState() {
    return this.isScrollingFlag;
  }

  isScrollingController(state) {
    this.isScrollingFlag = state;
  }

  unloadData() {
    var ac = ac || this.lastReportedSlug;
    if (!ac) return;
    const nodes = Array.prototype.slice.call(document.querySelector(`#${ac}`).parentElement.children);
    const index = nodes.indexOf(document.querySelector(`#${ac}`));
    let count = 0;
    for (let i = 0; i < this.indT.length; ++i) {
      if (this.indT[i] === index - 1) count++;
    }
    if (count === 4) {
      this.scroll100Indicator = 1;
    } else {
      this.scroll100Indicator = 0;
    }
    const statElementArray = [];

    const { scroll100Indicator } = this;

    for (const pos in this.statElementCollector) {
      statElementArray.push(this.statElementCollector[pos]);
    }
    const cScrollPercentValue = cScrollPercent.burp() || 0;

    try {
      WP.pwp.closePage({
        ga: {
          event: 'unload',
          page: {
            sliderConsumption: statElementArray,
            content: { section: { scroll100Indicator } },
            ac,
            templateType: 'AS',
          },
          content: {
            pageViewCount: 1,
            scrollPercent: '',
            cScrollPercent: cScrollPercentValue,
            cS: cScrollPercentValue,
          },
        },
      });
      // console.log(dataLayer);
    } catch (error) {
      console.error('błąd wpjslib: ', error);
    }
  }
}

export const contest = new Contest();
